import { createSelector } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "shared/constants";

import { IDataKeys, IPhoneNumber } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { dataSelector, buildData } from "../helpers";

export const userPhoneNumbersSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.userPhoneNumber) as IPhoneNumber[]
);

const dataUserPhoneNumbersSelector = createSelector(dataSelector, data => data.userPhoneNumber);

export const userPhoneNumberSelectorCreator = (id: string) =>
  createSelector(dataUserPhoneNumbersSelector, data => {
    const item = data?.[API_ENDPOINTS.USER_PHONE_NUMBER(id)];
    return item ? buildSingleItem(item) : undefined;
  });
